import React, {useState} from 'react';
import {connect} from 'react-redux';
import TranslateTag from '../../../../Utils/Local/TranslateTag';
import MapButtonsToContextMenu from '../../../../Utils/Forms/MapButtonsToContextMenu';
import FormDefinitionSection from './FormDefinitionSection/FormDefinitionSection';
import FormHandler from '../../../Containers/FormHandler/FormHandler';
import './FormDefinition.css';
import PageHeader from './PageHeader/PageHeader';

const FormDefinition = (props) => {

    const [selectedIndex, setSelectedIndex] = useState({});
    const [formStartConfig, setFormStartConfig] = useState({});
    const [listVisibility, setListVisibility] = useState(true);

    const displayList = [];
    let form = "";

    if (props.data !== undefined && props.data.length > 0) {
        var pages = props.data[0].pages;
        var keys = Object.keys(pages);
        form = props.data[0].form;

        for (let x = 0; x < keys.length; x++) {
            const page = pages[x];

            const fieldList = [];
            if (page.Columns !== undefined) {
                for (const column of page.Columns) {
                    for (const formGroup of column.FormGroups) {
                        for (const field of formGroup.Fields) {
                            let stateId = field.Configurable === "No" ? "none" : "canconfig";
                            if (stateId == "canconfig") {
                                const editForm = props.forms.filter(f => f.Name === "editfieldform")
                                stateId = editForm.length > 0 ? stateId : "candelete";
                                const deleteForm = props.forms.filter(f => f.Name === "deletefieldform")
                                stateId = deleteForm.length > 0 ? stateId : stateId === "canconfig" ? "canedit" : "none";
                            }
                            fieldList.push({Id: form + "|" + page.Name + "|" + field.Id, DisplayId: field.Id, Label:field.Label, Type: field.Type, stateid: stateId})
                        }
                    }
                }
            }

            const newDisplay = { pageTitle: page.PageTitle, id: page.Name, fields: fieldList, configureActions: page.ConfigureActions};
            displayList.push(newDisplay);
        }
    } 

    const refreshAfterReturningFromForm = () => {
        props.onRefresh("formdefinitionrefresh" );
    }

    const setFormConfig = (button, recordId) => {
        setFormStartConfig({
            button: button, 
            id: recordId, 
            refresh: refreshAfterReturningFromForm,
            containerVisibility: setListVisibility
        })
    }

    const buttonClickHandler = (button, item) => {
        const id = item.id === undefined ? item.Id : item.id;
        setFormConfig(button, id )
    }

    const selectionChangeHandler = (selectionState) => {
        setSelectedIndex(selectionState.getSelectedIndices());
    }

    const itemSelected = (item, selected) => {
        if (selected) {
            var arrayOfSelectedItems = [];
            arrayOfSelectedItems[0] = item;
        }
    }

    const embeddedModeButtonHandler = (item, button) => {
        itemSelected(item, true);
        buttonClickHandler(button, item);
    }

    const menuButtons = [
        {Icon: "Edit", Key: "editfield", PrimaryAction: true, Text: TranslateTag("@ConEdiK@",props.language), UIEvent: "editfielduievent", EntryStates: "canconfig, canedit", Workflow: true, OnFinish: "refresh"},
        {Icon: "Delete", Key: "deletefield", PrimaryAction: true, Text: TranslateTag("@ConDelK@",props.language), UIEvent: "deletefielduievent", OnFinish: "refresh", EntryStates: "canconfig, candelete", Workflow: true }
    ];

    let addButton = undefined;
    const addForm = props.forms.filter(f => f.Name === "addfieldform");
    if (addForm.length > 0) {
        addButton = "addfielduievent";
    }

    const menuItems = MapButtonsToContextMenu(menuButtons, buttonClickHandler);

    const columns = [
        { Key: 'column2', Name: TranslateTag("@GenLabB@",props.language), FieldName: 'Label', MinWidth: 180, MaxWidth: 180, IsResizable: true, IsCollapsible: true },
        { Key: 'menu', Name: '', FieldName: '', MinWidth: 120, MaxWidth: 120, IsResizable: true, IsCollapsible: false },
        { Key: 'column3', Name: TranslateTag("@GenTyp@",props.language), FieldName: 'Type', MinWidth: 180, MaxWidth: 180, IsResizable: true, IsCollapsible: true },
    ];

    const editClickHandler = (page) => {
        setFormStartConfig({
            button: {UIEvent: "editpageuievent", onFinish: 'refresh'}, 
            id: props.data[0].form + "|" + page.id, 
            refresh: refreshAfterReturningFromForm,
            containerVisibility: setListVisibility
        })
    }

    const deleteClickHandler = (page) => {
        setFormStartConfig({
            button: {UIEvent: "deletepageuievent", onFinish: 'refresh'}, 
            id: props.data[0].form + "|" + page.id, 
            refresh: refreshAfterReturningFromForm,
            containerVisibility: setListVisibility
        })
    }

    // Display list controls.
    const listContentCss = listVisibility ? "" : " app-invisible";

    let forms = props.forms.filter(f => f.Name === "editpageform");
    const displayEditButton = forms.length > 0;
    forms = props.forms.filter(f => f.Name === "deletepageform");
    const displayDeleteButton = forms.length > 0;

    return (
        <div className='directtestsgrid-content'>
            {displayList.map((page) => {
                return (
                    <div key={page.id} className={listContentCss}>
                        <PageHeader page={page} canEdit={displayEditButton} canDelete={displayDeleteButton} edit={editClickHandler} delete={deleteClickHandler}></PageHeader>
                        <FormDefinitionSection 
                            type={"grid"}
                            parentId={form + "|" + page.id}
                            refresh={props.refresh}
                            columns={columns}
                            listData={page.fields}
                            menuItems={menuItems}
                            itemSelected={itemSelected}
                            selectedRecord={selectedIndex}
                            selectionChanged={selectionChangeHandler}
                            basicModeButtonHandler={embeddedModeButtonHandler}
                            onClick={buttonClickHandler}
                            page={page}
                            addButton={addButton}>
                        </FormDefinitionSection>
                    </div>
            )})}
            <FormHandler startConfig={formStartConfig} showNextButton={false}></FormHandler>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        forms: state.config.forms
    };
}

export default connect(mapStateToProps)(FormDefinition);